import DetailsInitial from "../elements/details-initial";
import DetailsCurrent from "../elements/details-current";
import DetailsFromStart from "../elements/details-from-start";
import DetailsSigns from "../elements/details-signs";
import DetailsStopNote from "../elements/details-stop-note";
import { StrategyOverviewType } from "../../../types/details";
import { StrategyStatus } from "../../../const";
import DetailsYourChanges from "../elements/details-your-changes";
import { useAppSelector } from "../../../hooks";

type BlockStoppingProps = {
  overview: StrategyOverviewType;
  isTabletAndMore: boolean;
};

export default function BlockStopping({
  overview,
  isTabletAndMore,
}: BlockStoppingProps): JSX.Element {
  const { userAmountChanges } = useAppSelector((state) => state);

  const currentUserAmountChange =
    userAmountChanges?.find((el) => el.code === overview.code)
      ?.userAmountChanges ?? 0;

  return (
    <div className="block-stopping">
      <div className="block-stopping__total-wrapper">
        <DetailsInitial
          overview={overview}
          strategyStatus={StrategyStatus.Stopping}
          isTabletAndMore={isTabletAndMore}
        />
        <DetailsCurrent
          overview={overview}
          strategyStatus={StrategyStatus.Stopping}
          isTabletAndMore={isTabletAndMore}
        />
      </div>
      <div className="block-stopping__total-wrapper">
        <DetailsFromStart
          overview={overview}
          strategyStatus={StrategyStatus.Stopping}
          isTabletAndMore={isTabletAndMore}
        />
        <DetailsYourChanges
          overview={overview}
          strategyStatus={StrategyStatus.Started}
          isTabletAndMore={isTabletAndMore}
          currentUserAmountChange={currentUserAmountChange}
        />
      </div>

      <DetailsSigns
        overview={overview}
        strategyStatus={StrategyStatus.Stopping}
        currentUserAmountChange={currentUserAmountChange}
        isYourChanges
      />

      <div className="block-stopping__note-wrapper">
        <DetailsStopNote />
      </div>
    </div>
  );
}
